'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_display_Icon_Icon = require('../../display/Icon/Icon.cjs.js');
const components_patterns_ServiceIcon_ServiceIcon = require('../../patterns/ServiceIcon/ServiceIcon.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_1eqo5_1";
const step = "_step_1eqo5_7";
const stepName = "_step-name_1eqo5_22";
const divider = "_divider_1eqo5_31";
const styles = {
	root: root,
	step: step,
	stepName: stepName,
	divider: divider
};

const ZapCardStep = (props) => {
  const isTrigger = props.index === 0;
  const divider = !isTrigger && React__default.default.createElement(
    "div",
    { className: styles.divider, "data-zds": true },
    React__default.default.createElement(components_display_Icon_Icon.Icon, { color: "GrayWarm2", name: "formAddCircle", size: 18 })
  );
  return React__default.default.createElement(
    "li",
    { className: styles.step, "data-zds": true },
    divider,
    React__default.default.createElement(components_patterns_ServiceIcon_ServiceIcon.ServiceIcon, { "aria-hidden": true, serviceName: props.name, size: "medium", src: props.icon }),
    React__default.default.createElement(
      "div",
      { "data-zds": true },
      React__default.default.createElement("p", { "data-zds": true }, isTrigger ? "When this happens" : "Then do this"),
      React__default.default.createElement(
        "p",
        { className: styles.stepName, "data-zds": true },
        "Step ",
        props.index + 1,
        ": ",
        props.label
      )
    )
  );
};
const ZapCardSteps = (props) => {
  return React__default.default.createElement("ol", { className: styles.root }, props.steps.map((step, i) => {
    return React__default.default.createElement(ZapCardStep, Object.assign({}, step, { index: i, key: i }));
  }));
};

exports.ZapCardSteps = ZapCardSteps;
//# sourceMappingURL=ZapCardSteps.cjs.js.map
